import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Toolbar, Grid, Button, Card, CardContent } from "@material-ui/core";
import { GlobalHeader } from "components/navigation/components/GlobalHeader";
import BreadcrumbsHeader from "components/navigation/BreadcrumbsHeader";
import CustomInput from "components/custom/CustomInput";
import KisshtTable from "components/table/KisshtTable";
import { RobotFont } from "components/ui/RobotFont";
import Colors from "shared/color";
import Header from "components/navigation/Header";
import EditIcon from "@material-ui/icons/Edit";
import VisibilityIcon from '@material-ui/icons/Visibility';
import CustomSelect from "components/custom/CustomSelect";
import {fetchOfferMapListV2, fetchOfferMapViewDataV2 } from "shared/api/MerchantOfferV2/offermap";
import { useHistory } from "react-router-dom";
import moment from "moment";
import './merchantOffer.css'
import PermissionButton from 'components/ui/form/PermissionButton';
import { PERMISSIONS, ROUTE_NAME } from 'shared/constants';
import KisshtButton from "components/ui/KisshtButton";
import CommonSelect from "components/custom/CommonSelect"

let offset = 1;
export const MerchantOfferMapV2 = (props) => {
  let history = useHistory();
  
  const { params, updateQueryParams } = props;
  const [search, setSearch] = useState("");
  const [spinning, setSpinning] = useState(false);
  const [offerData, setOfferData] = useState([]);
  const [offerDataCount, setOfferDataCount] = useState([]);
  const [isEditing, setisEditing] = useState(true);
  const [reload, setReload] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState(params["selectedFilter"] || "");
  const [offerDropDownData, setOfferDropDownData] = useState([]);
  const [newList, setnewList] = useState();

  const fetchOfferMapListing = async () => {
    setSpinning(true);
    await updateQueryParams({ search });
    let jsonParams={
      limit:"20",
      offset:offset-1
    }
    fetchOfferMapListV2(selectedFilter, search, jsonParams)
      .then((res) => {
        setSpinning(false);
        setOfferData([]);
        if (res.hasOwnProperty("success") && res.success) {
          const { data } = res;
          if (data?.list?.length > 0) {
            setOfferData(data?.list);
            setOfferDataCount(data?.count);
            setOfferDropDownData(data?.list);
          } else {
            setOfferData([]);
          }
        }
      })
      .catch((error) => {
        setOfferData([]);
        setSpinning(false);
      });
  };
let offerDropDownDataArray = [];

offerDropDownDataArray = offerDropDownData?.map(items => {return {value:items.offer_mapping_id, label:items.offer_map_name}})

  const merchantOfferMapView = (data) => {
    let merchantOfferReferenceNumber =  data?.original?.merchant_offer_reference_number;
    window.open(`/merchant-offer-map/view/${merchantOfferReferenceNumber}`, "_blank" );
  }

  const merchantOfferMapEdit = async (data) => {
    let mapViewData;
    let merchantOfferReferenceNumber =  data?.original?.merchant_offer_reference_number;
    await fetchOfferMapViewDataV2(merchantOfferReferenceNumber).then((res) => {
      if (res.message === "Success") {
        mapViewData = res.data;
      }
    });
  
      history.push({
        pathname: `/merchant-offer-map/edit/${merchantOfferReferenceNumber}`,
        state: {
          merchnat_data: data?.original,
          isEditing: isEditing,
          mapViewData: mapViewData,
        },
        target: "_blank",
      }); 
    // }
     
    
  }

  const addClickHandler =  (e) => {
    window.open("/merchant_offer_map_add");
    setisEditing(false);

  };
  
  useEffect(() => {
    fetchOfferMapListing();
    offset = 1
    // eslint-disable-next-line
  },[reload]);

  const funData = (cell) =>{
     return moment(cell).format("DD-MM-yyyy HH:MM:SS")
  }

  const columns = [
    {
      Header: "Offer Map Id",
      accessor: "offer_mapping_id",
      sortable: false,
      Cell: (cell) => {
        return <RobotFont type="medium">{cell.value}</RobotFont>;
      },

      headerStyle: {},
      filterable: false,
    },
    {
      Header: "Merchant Offer Reference Number",
      accessor: "merchant_offer_reference_number",
      sortable: false,
      Cell: (cell) => {
        return <RobotFont type="medium">{cell.value}</RobotFont>;
      },

      headerStyle: {},
      filterable: false,
    },
    {
      Header: "Offer Map Name	",
      accessor: "offer_map_name",
      sortable: false,
      filterable: false,
      headerClassName:"common_medium_tablewidth",
      Cell: (cell) => {
      return <RobotFont type="medium">{cell.value}</RobotFont>
      }
    },
    {
      Header: "No Of Bucket	",
      accessor: "no_of_offer_bucket",
      filterable: false,
      sortable: false,
      Cell: (cell) => {
      return <RobotFont type="medium">{cell.value}</RobotFont>
    }
    },
    {
      Header: "Created Date",
      accessor: "created_at",
      filterable: false,
      sortable: false,
      headerClassName:"common_small_tablewidth",
      Cell: (cell) => {
        return <span>{funData(cell.value)}</span>
      },
    },
    {
      Header: "Action",
      accessor: "id",
      filterable: false,
      sortable: false,
      headerClassName:"common_small_tablewidth",
      Cell: (cell) => {
        return (
          <>
            <Grid container spacing={1} className="space_btn_table">
              <Grid item>
                <PermissionButton
                  style={{ border: "none" }}
                  size="small"
                  variant="outlined"
                  onClick={() => merchantOfferMapView(cell)}
                  route={ROUTE_NAME.merchant_offer_map}
                  permission={PERMISSIONS.merchant_offer_map.offer_map_view}
                  startIcon={<VisibilityIcon />}
                ></PermissionButton>
              </Grid>
              <Grid item>
                <PermissionButton
                  style={{ border: "none" }}
                  size="small"
                  variant="outlined"
                  onClick={() => merchantOfferMapEdit(cell)}
                  route={ROUTE_NAME.merchant_offer_map}
                  permission={PERMISSIONS.merchant_offer_map.offer_map_update}
                  startIcon={<EditIcon />}
                ></PermissionButton>
              </Grid>
            </Grid>
          </>
        );
      },
    },
  ];
  const handleSelect = async (e) => {
    e.persist();
    if (e) {
      let item = e.target.value;
      if (!item) {
        setSearch("");
        setReload(!reload);
      }
      setSelectedFilter(item);
      setSearch("");
    }
  };
  
  const refreshHandler = async () => {
    offset = 1;
    setSearch("");
    setSelectedFilter("");
    setnewList("");
    setReload(!reload);
  };
  const onPageChange = (value) => {
    offset = value;
    fetchOfferMapListing();
  };

const handleSearch = async (e) => {
  e.preventDefault();
  if (!search.length)
  return false;
  offset = 1;
  setSpinning(true);
  updateQueryParams({search});
  fetchOfferMapListing();
};

return (
    <>
         <Header open={props.open}>
        <Toolbar
          style={{
            backgroundColor: Colors["AppBarBGPurple"],
            minHeight: "65px",
          }}
        >
          <GlobalHeader />
        </Toolbar>
        <Toolbar>
          <Grid container alignItems="center" className='crum_padding'>
              <Grid container spacing={1} alignItems="center">
                <Grid item lg={3} md={3} sm={8} xs={6}>
                    <BreadcrumbsHeader text="Offers Map Table" />
                </Grid>
                
                <Grid item lg={9} md={9} sm={4} xs={12} className='top_spacing_btn'>
                  <Grid container justifyContent="flex-end">
                    <Grid item>
                        <KisshtButton
                          variant="contained"
                          color="primary"
                          size="small"
                          route={ROUTE_NAME.merchant_offer_map}
                          permission={PERMISSIONS.merchant_offer_map.offer_map_create}
                          onClick={() => addClickHandler()}
                          className="common_kissht_btn"
                        >Add New</KisshtButton>
                      </Grid>
                  </Grid>
              </Grid>
              </Grid>
              <Grid item xs={12} className="crum_innerPadding">
              <Grid container spacing={1} alignItems="center">
                <Grid item>
                  <CustomSelect
                    multiple={false}
                    options={{
                      offer_map_name: "Offer Map Name",
                      offer_mapping_id: "Offer Map Id",
                      merchant_offer_reference_number: "Merchant Offer Reference Number",
                    }}
                    value={selectedFilter}
                    onChange={handleSelect}
                    nulloption="Select Filter Options"
                    className="common_global_filter"
                  />
                </Grid>
                  <Grid item>
                  <CustomInput
                    onChange={(e) => setSearch(e.target.value)}
                    value={search}
                    placeholder="Search"
                    className="common_custom_input"
                  />
                </Grid>
                <Grid item >
                   <CommonSelect                       
                        placeholder="Select Map Name"
                        onChange={(selectedOption) =>setnewList(selectedOption.value)}
                        value={newList}
                        isSearchable={true}
                        options={offerDropDownDataArray}
                        name="offer_map_name"
                        id="offer_map_name"
                        isLoading={false}
                        loadingMessage={() => "Fetching offer_map_name"}
                        noOptionsMessage={() => "offer_map_name"}
                        maxMenuHeight={110}
                        className="common_global_filter"
                    />
                  </Grid>
                  <Grid item>
                    <Button
                      disabled={selectedFilter && search ? false : true}
                      variant="contained"
                      className="shadow-none common_kissht_btn"
                      color="primary"
                      onClick={handleSearch}
                    >
                      Search
                    </Button>
                </Grid>
                <Grid item>
                    <Button onClick={refreshHandler} size="small" color="primary">
                      Reset
                    </Button>
                  </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Toolbar>
      </Header>

      <div className="common_padding_from_title_withLessFilter">
        <Card
          style={{
            boxShadow: `0px 3px 6px ${Colors["LightPurpleShadow"]}`,
          }}
        >
          <CardContent style={{ height: "50px" }}>
            <Grid container className="grid-vertical-align-center">
              <Grid item xs={12}>
                <p
                  className="text-xs"
                  style={{
                    color: Colors["lightPurple"],
                    margin: "auto",
                  }}
                ></p>
              </Grid>
            </Grid>
          </CardContent>
          <CardContent className='table_card_mobile'>
            <KisshtTable
              loading={spinning}
              columns={columns}
              data={offerData}
              onPageChange={onPageChange}
              showPagination={true}
              offset={offset}
              totalCount={offerDataCount}
            />
          </CardContent>
        </Card>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, null)(MerchantOfferMapV2);
